module.exports = __webpack_public_path__ + "static/media/expire@3x.163a86b7.png";